import { ComponentTabItem, ComponentTabs } from "@picovico/ui";
import React, { useMemo } from "react";
import { getComponentByType } from "helpers";
import { componentByType } from "constants/componentByType";

type DynamicComponentTabItemWithString = Omit<ComponentTabItem, "component"> & {
  componentName: keyof typeof componentByType;
};

interface DynamicComponentTabsProps {
  tabList: (DynamicComponentTabItemWithString | ComponentTabItem)[];
}

function DynamicComponentTabs({ tabList }: DynamicComponentTabsProps) {
  const computedTabList = useMemo(() => {
    return tabList.map((tItem) => ({
      ...tItem,
      component:
        "component" in tItem
          ? tItem.component
          : getComponentByType(tItem.componentName),
    }));
  }, [tabList]);

  return <ComponentTabs tabList={computedTabList} />;
}

export default DynamicComponentTabs;
